export const SUPPORT_LINKS = {
  termsOfUse: 'https://documents.dsgd.gov.sg/Merchants_Terms.pdf',
  faq: 'https://documents.dsgd.gov.sg/Merchant%20FAQ.pdf',
  contactUs: 'https://wa.me/91526413',
}

export const MARKETING_LINKS = {
  ogp: 'https://www.open.gov.sg/',
}
